import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const AssignmentView = loadView('assignment/AssignmentView');

const assignmentRoute = {
  path: ROUTE.PATH.ASSIGNMENT,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [
      PRESCREENING.APPROVAL_KEY.APPROVED,
      PRESCREENING.APPROVAL_KEY.WALLET_FAILED,
    ],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.ASSIGNMENT,
      component: AssignmentView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [
          PRESCREENING.APPROVAL_KEY.APPROVED,
          PRESCREENING.APPROVAL_KEY.WALLET_FAILED,
        ],
      },
    },
  ],
};

export default assignmentRoute;
